const viewItemTemplate = {
  event: 'view_item', // A default GA4 event
  item_name: null,
  item_id: null, // The event ID
  days_to_event: null, // Where 1.50 would mean 36 hours
  event_name: null, // In English, defaulting to the local language, in base64
  genre: null, // One of "sports", "concerts", "theater", "other"
  inventory_market: null, // One of "primary", "secondary", "blended"
  parent_id: null, // The item’s parent category ID as a string
  parent_tree: null, // /9/99/999/9999/ the item’s category tree as string (notice the starting and ending "/" characters)
  country_code: null, // The item’s country as a two-letter ISO code
  item_list_id: null,
  items: null,
  entity_name: null, // In English, defaulting to the local language, in base64
};

export default viewItemTemplate;
